module.exports = new __parcel__URL__("linkedin.08fd1bea.svg").toString();